import localforage from "localforage";
import reject from "lodash/reject";
import { phpRequest } from "./phpRequest";
import { generateRecursiveList } from "../helpers/generateRecursiveList";
import { flatMultiDimensional } from "../helpers/flatMultiDimensional";
import { request } from "./request";
import { checkHasPermission } from "@/helpers/checkHasPermission";

const nubis_v2 = "/nubis/v2";
const nubis_v3 = "/nubis/v3";
const platform_v3 = "/platform/v3";

export function checkIf2FA(ticket) {
  return request.post(platform_v3 + "/check_otp", {
    ticket,
    platform: "fec-nubis"
  });
}

export function sendEmailVerifyCode(params) {
  return request.post(platform_v3 + "/send_otp_code", {
    ...params,
    platform: "fec-nubis"
  });
}

export function checkEmailVerifyCode(params) {
  return request.post(platform_v3 + "/verify_otp_code", {
    ...params,
    platform: "fec-nubis"
  });
}

export function importGroupsAPI(params) {
  return phpRequest.post("/groups/upload", params);
}

export function moveGroupAPI(params) {
  return phpRequest.post("/groups/move", params);
}

export async function createGroupApi(params) {
  const res = await phpRequest.post("groups/create", params);
  return res.group;
}

export function updateGroupApi(params) {
  return phpRequest.put("groups/update", params);
}

export function deleteGroupApi(params) {
  return phpRequest.delete("groups/delete", params);
}

export function deleteFileApi(params) {
  return phpRequest.delete("drive/file/delete", params);
}

export async function getCompanyTreeAPI(loadUsers) {
  const company_id = await localforage.getItem("companyId");
  const user = await localforage.getItem("user");
  const data = await phpRequest.get("/company-tree", {
    company_id,
    user_id: user.id
  });
  if (data && data.companies) {
    const companyTreeArr = generateRecursiveList(data.companies, loadUsers);
    const flattenSubCompaniesArr = flatMultiDimensional(data.companies);
    const flattenCompanyTreeWithoutHQ = reject(
      flattenSubCompaniesArr,
      function (o) {
        return !o.parent_company_id;
      }
    );
    // await localforage.setItem("companyTree", companyTreeArr);
    // await localforage.setItem("flattenCompanyTree", flattenSubCompaniesArr);
    // await localforage.setItem(
    //   "flattenCompanyTreeWithoutHQ",
    //   flattenCompanyTreeWithoutHQ
    // );
    return {
      companyTree: companyTreeArr,
      flattenCompanyTree: flattenSubCompaniesArr,
      flattenCompanyTreeWithoutHQ
    };
  }
  return {
    companyTree: [],
    flattenCompanyTree: [],
    flattenCompanyTreeWithoutHQ: []
  };
}

export async function getDeviceListFieldsApi(params, config) {
  const res = await request.post(
    nubis_v3 + "/get_device_list_fields",
    params,
    config
  );
  return JSON.parse(res.deviceListFields);
}

export function updateDeviceListFieldsApi(params) {
  return request.post(nubis_v3 + "/update_device_list_fields", params);
}

export function getGroupTokenApi(params) {
  return request.post(nubis_v3 + "/get_group_token", params);
}

export function renewGroupTokenApi(params) {
  return request.post(nubis_v3 + "/renew_group_token", params);
}

export function getUserListApi(params, config) {
  return request.post(nubis_v3 + "/get_user_list", params, config);
}

export function updateUserInvisibleGroupApi(params) {
  return request.post(nubis_v3 + "/update_user_invisible_group", params);
}

export function getRoleListApi(params) {
  return request.post(nubis_v3 + "/get_role_list", params);
}

export function updateDeviceDetailApi(params) {
  return request.post(nubis_v3 + "/update_device_detail", params);
}

export function updateDeviceNameApi(params) {
  return phpRequest.put("/device/name", params);
}

export function getAlarmPolicyList(params) {
  return phpRequest.get("/alarm/policy/options", params);
}

export function getAlarmTemplatesApi(params) {
  return phpRequest.get("/alarm/template/datatable", params);
}

export function createAlarmTemplateApi(params) {
  return phpRequest.post("/alarm/template/create", params);
}

export function updateAlarmTemplateStatusApi(params) {
  return phpRequest.post("/alarm/template/updateStatus", params);
}

export function deleteAlarmTemplateStatusApi(params) {
  return phpRequest.delete("/alarm/template/delete", params);
}

export function updateAlarmTemplateApi(params) {
  return phpRequest.put("/alarm/template/update", params);
}

export function alarmTemplateDetailApi(params) {
  return phpRequest.get("/alarm/template/detail", params);
}

export function getAlarmTemplateDevicesApi(params) {
  return phpRequest.get("/alarm/template/devices", params);
}

export function getCMSHistoryTemplateDevicesApi(params) {
  return request.post(
    nubis_v3 + "/content_template_history_device_list",
    params
  );
}

export function getCompanyAccounts(params) {
  return phpRequest.get("/company/accounts", params);
}

export function bindDevicesTemplatesApi(params) {
  return phpRequest.post(
    "/alarm/deploy/assign-alarm-template-to-devices",
    params
  );
}

export function unbindDevicesTemplatesApi(params) {
  return phpRequest.delete("/alarm/deploy/unbind-devices-templates", params);
}

export function getUsersByIdApi(params) {
  return phpRequest.get("/accounts/detail", params);
}

export function getCompanyImage() {
  return phpRequest.get("/company/image");
}

export function getAlarmDeviceListApi(params) {
  return request.post(nubis_v3 + "/alarm_device_list", params);
}

export function getAlarmHistoryListApi(params) {
  return request.post(nubis_v3 + "/alarm_history_list", params);
}

export function getTriggeredDeviceList(params) {
  return request.post(nubis_v3 + "/triggered_device_list", params);
}

export function getFailedScheduleDeviceListApi(params) {
  return request.post(nubis_v3 + "/failed_scheduled_device_list", params);
}

export function getDeviceAlarmListApi(params) {
  return request.post(nubis_v3 + "/device_alarm_list", params);
}

export function resetAlarmDeviceApi(params) {
  return request.post(nubis_v3 + "/reset_device", params);
}

export function deleteAlarmDeviceApi(params) {
  return request.post(nubis_v3 + "/delete_alarm_history", params);
}

export function getGroupDeviceList(params) {
  return request.post(nubis_v3 + "/group_device_list", params);
}

export function getAlarmedTemplateListApi(params) {
  return request.post(nubis_v3 + "/alarmed_template_list", params);
}

export function getAlarmedPolicyListApi(params) {
  return request.post(nubis_v3 + "/alarmed_policy_option_list", params);
}

export function statisticDevicesApi(params) {
  return phpRequest.get("/devices/filter", params);
}

export function getAlarmTemplateCreatorsApi(params) {
  return phpRequest.get("/alarm/template/creator/list", params);
}

export function getAlarmDeviceDeployerList(params) {
  return request.post(nubis_v3 + "/alarm_device_deployer_list", params);
}

export function saveDashboradSortResultApi(params) {
  return request.post(nubis_v3 + "/update_dashboard_module_order", params);
}

export function getDashboradSortResultApi(params) {
  return request.post(nubis_v3 + "/get_dashboard_module_order", params);
}

export function getFileConfigRefList(params) {
  return request.post(nubis_v3 + "/file_references_config_list", params);
}

export function getFileSharedInfo(params) {
  return request.post(nubis_v3 + "/file_shared_info", params);
}

export function createEventApi(
  task_type,
  ext,
  schedule_type,
  cycle_type,
  dailyTimes,
  weeklyTimes,
  weeklySelect,
  end_type,
  times,
  start_datetime,
  end_datetime
) {
  let cycle_value;
  if (schedule_type === "daily") {
    cycle_value = cycle_type === "every" ? dailyTimes.toString() : "workdays";
  } else {
    cycle_value = weeklyTimes.toString();
  }
  let cycle_days = [];
  Object.entries(weeklySelect).forEach(([key, value]) => {
    if (value === true) {
      cycle_days.push(key);
    }
  });
  return phpRequest.post("/schedule/event/create/new", {
    task_type,
    ext: typeof ext === "object" ? ext.id : ext,
    schedule_type,
    cycle_type: schedule_type === "weekly" ? "weekly_days" : cycle_type,
    cycle_value,
    cycle_days: schedule_type === "weekly" ? cycle_days : undefined,
    end_type,
    run_times: end_type === "times" ? times : 0,
    start_datetime,
    end_datetime,
    os_type: task_type==="start"? 2: (task_type==="shutdown" && !checkHasPermission("schedule_task_android_power_off"))? 2: 0
  });
}

export function editEventApi(
  id,
  task_type,
  ext,
  schedule_type,
  cycle_type,
  dailyTimes,
  weeklyTimes,
  weeklySelect,
  end_type,
  times,
  start_datetime,
  end_datetime
) {
  let cycle_value;
  if (schedule_type === "daily") {
    cycle_value = cycle_type === "every" ? dailyTimes.toString() : "workdays";
  } else {
    cycle_value = weeklyTimes;
  }
  let cycle_days = [];
  Object.entries(weeklySelect).forEach(([key, value]) => {
    if (value === true) {
      cycle_days.push(key);
    }
  });
  return phpRequest.put("/schedule/event/update/new", {
    id,
    task_type,
    ext: typeof ext === "object" ? ext.id : ext,
    schedule_type,
    cycle_type: schedule_type === "weekly" ? "weekly_days" : cycle_type,
    cycle_value,
    cycle_days: schedule_type === "weekly" ? cycle_days : undefined,
    end_type,
    run_times: end_type === "times" ? times : 0,
    start_datetime,
    end_datetime
  });
}

export function createScheduleTemplate(params) {
  return phpRequest.post("/schedule/template/create", params);
}

export function updateScheduleTemplate(params) {
  return phpRequest.put("/schedule/template/update", params);
}

export function getScheduleTemplateInfo(params) {
  return phpRequest.get("/schedule/template/detail", params);
}

export function getScheduleTemplatesApi(params) {
  return phpRequest.get("/schedule/template/list", params);
}

export function getScheduleTemplateCreatorsApi(params) {
  return phpRequest.get("/schedule/template/creator/list", params);
}

export function scheduleTemplatesActionApi(params) {
  return phpRequest.put("/schedule/template/action", params);
}

export function bindDevicesScheduleTemplatesApi(params) {
  return phpRequest.post("/schedule/deploy/templates", params);
}

export function unbindDevicesScheduleTemplatesApi(params) {
  return phpRequest.delete("/schedule/deploy/unbind", params);
}

export function getCalendarEventListApi(
  group_ids,
  tag_ids,
  device_id,
  device_sn,
  target_type,
  start_date,
  end_date
) {
  return phpRequest.get("/schedule/event/calendar", {
    group_ids,
    tag_ids,
    device_id,
    device_sn,
    target_type,
    start_date,
    end_date
  });
}

export function getCalendarEventExecutionStatusApi(
  group_ids,
  tag_ids,
  device_id,
  device_sn,
  target_type,
  start_date,
  end_date
) {
  return phpRequest.get("/schedule/event/execution/status", {
    group_ids,
    tag_ids,
    device_id,
    device_sn,
    target_type,
    start_date,
    end_date
  });
}

export function getScheduleEventDevices(params) {
  return phpRequest.get("/schedule/event/devices", params);
}

export function getScheduleDeployUsers(params) {
  return phpRequest.get("/schedule/deploy/users", params);
}

export function scheduleDeviceStatusApi(params) {
  return phpRequest.put("/schedule/deploy/schedule/status", params);
}

export function getScheduleTemplateDevicesApi(params) {
  return phpRequest.get("/schedule/template/devices", params);
}

export function getDeviceScheduleApi(params) {
  return phpRequest.get("/device/schedule", params);
}

export function checkLoginPassword(params) {
  return phpRequest.post("/account/validate/password", params);
}

export function getScheduleDeviceListApi(params) {
  return request.post(nubis_v3 + "/schedule_device_list", params);
}

export function getScheduledDeviceHistoryListApi(params) {
  return request.post(nubis_v3 + "/scheduled_device_history_list", params);
}

export function deleteScheduledDeviceHistoryApi(params) {
  return request.post(nubis_v3 + "/delete_scheduled_device_history", params);
}

export function getAndroidAppList(params) {
  return phpRequest.get("/drive/file/datatable", params);
}

export function androidAppUploadCheck(params) {
  return phpRequest.post("/drive/file/upload-verify", params);
}

export function setFileConfig(params) {
  return phpRequest.post("/drive/file/config", params);
}

export function getProfileConfigList(params) {
  return request.post(nubis_v3 + "/config_list", params);
}

export function getPrinterList(params) {
  return request.post(nubis_v3 + "/device_printer_list", params);
}

export function removePrinter(params) {
  return request.post(nubis_v3 + "/remove_device_printer", params);
}

export function getProfileConfigInfo(params) {
  return request.post(nubis_v3 + "/config_info", params);
}

export function getProfileConfigHistoryInfo(params) {
  return request.post(nubis_v3 + "/config_history_info", params);
}

export function copyProfileConfig(params) {
  return request.post(nubis_v3 + "/copy_config", params);
}

export function deleteProfileConfig(params) {
  return request.post(nubis_v3 + "/delete_config", params);
}

export function updateProfileConfigStatus(params) {
  return request.post(nubis_v3 + "/update_config_status", params);
}

export function publishProfileConfig(params) {
  return request.post(nubis_v3 + "/publish_config", params);
}

export function addProfileConfig(params) {
  return request.post(nubis_v3 + "/add_config", params);
}

export function updateProfileConfig(params) {
  return request.post(nubis_v3 + "/update_config", params);
}

export function setProfileConfigGroup(params) {
  return request.post(nubis_v3 + "/config_group", params);
}

export function getProfileConfigGroup(params) {
  return request.post(nubis_v3 + "/config_group_list", params);
}

export function getNamingGroupList(params) {
  return request.post(nubis_v3 + "/naming_rule_group_list", params);
}

export function getProfileConfigHistoryList(params) {
  return request.post(nubis_v3 + "/config_history_list", params);
}

export function getProfileConfigHistoryDeviceList(params) {
  return request.post(nubis_v3 + "/config_history_device_list", params);
}

export function createNamingApi(params) {
  return request.post(nubis_v3 + "/add_naming_rule", params);
}

export function updateNamingApi(params) {
  return request.post(nubis_v3 + "/update_naming_rule", params);
}

export function getNamingInfoApi(params) {
  return request.post(nubis_v3 + "/naming_rule_info", params);
}

export function getNamingList(params) {
  return request.post(nubis_v3 + "/naming_rule_list", params);
}

export function updateNamingStatus(params) {
  return request.post(nubis_v3 + "/update_naming_rule_status", params);
}

export function deleteNamingApi(params) {
  return request.post(nubis_v3 + "/delete_naming_rule", params);
}

export function applyNamingApi(params) {
  return request.post(nubis_v3 + "/apply_naming_rule", params);
}

export function appliedNamingGroupsApi(params) {
  return request.post(nubis_v3 + "/naming_rule_group_list", params);
}

export function getCompanySettingInfo(params) {
  return request.post(nubis_v3 + "/company_info", params);
}

export function updateCompanySettingInfo(params) {
  return request.post(nubis_v3 + "/update_company", params);
}

export function getMerchantConfigInfo(params) {
  return request.post(nubis_v3 + "/group_info", params);
}

export function getDeviceCountByKioskMode(param) {
  return request.post(nubis_v3 + "/device_count_by_kiosk_mode", param);
}

export function updateCompanyOraAutoUpdate(param) {
  return request.post(nubis_v3 + "/update_company_ora_auto_upd", param);
}

export function getTermList(param) {
  return request.post(platform_v3 + "/user_term_list", param);
}

export function confirmTerm(param) {
  return request.post(platform_v3 + "/confirm_term", param);
}

/**
 *
 * @param {deviceId: string, executeType: string}
 * @returns
 */
export function getLastTaskInfo(param) {
  return request.post(nubis_v3 + "/last_task_info", param);
}

export function getAccountInfo(params) {
  return phpRequest.get("/account/info", params);
}

export function getNubisDriveFileList(params) {
  return phpRequest.get("/drive/file/datatable", params);
}

export function getStoreDetailApi(param) {
  return phpRequest.get("/groups/edit", param);
}

export function sendRefreshSoftwareCommand(device_ids) {
  return phpRequest.post("/command/refresh-software-send", {
    device_ids,
    execute_type: "refresh_software_send"
  });
}

export function updateShareFileToCompanies(params) {
  return phpRequest.put("/drive/file/update-share-file-companies", params);
}

export function closeVNCLink(params) {
  return request.post(nubis_v3 + "/close_vnc", params);
}

export function getCMSResourceList(params) {
  return request.post(nubis_v3 + "/content_resource_list", params);
}

export function deleteCMSResource(params) {
  return request.post(nubis_v3 + "/delete_content_resource", params);
}

export function getCMSTemplateType(params) {
  return request.post(nubis_v3 + "/content_template_type_list", params);
}

export function createCMSTemplate(params) {
  return request.post(nubis_v3 + "/add_content_template", params);
}

export function editCMSTemplate(params) {
  return request.post(nubis_v3 + "/edit_content_template", params);
}

export function getCMSTemplateList(params) {
  return request.post(nubis_v3 + "/content_template_list", params);
}

export function getCMSTemplateHistory(params) {
  return request.post(nubis_v3 + "/content_template_history_list", params);
}

export function changeCMSContentDisplay(params) {
  return request.post(nubis_v3 + "/change_content_templates_display", params);
}

export function changeCMSContentStatus(params) {
  return request.post(nubis_v3 + "/change_content_templates_status", params);
}

export function applyCMSTemplate(params) {
  return request.post(nubis_v3 + "/content_template_apply_devices", params);
}

export function getCMSTemplateApplyedDeivces(params) {
  return request.post(
    nubis_v3 + "/content_template_latest_device_list",
    params
  );
}

export function getTemplateDetail(params) {
  return request.post(nubis_v3 + "/content_template", params);
}

export function getDevicesByGroupIdAndSearch(params) {
  return request.post(nubis_v3 + "/devices", params);
}

export function getCMSTemplateByDeviceId(params) {
  return request.post(nubis_v3 + "/content_templates_by_device", params);
}

export function getDevicesListExcel(params) {
  return phpRequest.get("devices/dataTables/download", params);
}

export function approveCMSResource(params) {
  return request.post(nubis_v3 + "/approve_content_resource", params);
}

export function getPersonalizedLanguageConfig(params) {
  return request.post(platform_v3 + "/personalize_config_info", params);
}
